import { FoodItemInputView } from "@corpuscomplete/web/components/nutrition/food-item";
import { FoodLogOnDate } from "@corpuscomplete/core-ui/nutrition/food-log";
import type { FoodLog } from "@corpuscomplete/core/nutrition/food-log";

/**
 * Logged food entry row adapter for the food-log timeline.
 * Contract: translate core-ui EntryItem callbacks into Zero mutations,
 * preserving entry identity and serving semantics.
 */
export function FoodLogOnDateEntryItem({ entry }: { entry: FoodLog.Entry }) {
  const { deleteEntry, editEntry } = FoodLogOnDate.useMutations();
  return (
    <FoodItemInputView
      className="flex-1 rounded-none px-0 py-1"
      itemInput={{ amount: entry.amount, foodServingId: entry.serving.id }}
      onEditItemAmount={(amount) => editEntry({ id: entry.id, amount })}
      onEditItemServing={(serving) =>
        editEntry({ id: entry.id, foodServingId: serving.id, amount: serving.defaultAmount })
      }
      onRemoveItem={() => deleteEntry(entry.id)}
    />
  );
}
